import * as React from 'react';
import SignIn from 'components/Auth/components/SignIn';
import {Text} from 'components/Auth/helpers';
import Link from '../../components/Link';
import {navigateTo} from "helpers/navigate-to";
import {Helmet} from 'react-helmet';

/**
 * The sign in page
 * @constructor
 */
export default function SignInPage(): React.ReactElement {
  /**
   * Render after.
   * @return {JSX.Element}
   */
  function renderAfter(): JSX.Element {
    return (
      <Text>
        Еще не зарегистрированы?
        {' '}
        <Link onClick={() => navigateTo('register')}>
          Регистрация
        </Link>
      </Text>
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Авторизация</title>
      </Helmet>
      <SignIn renderAfter={renderAfter()} />
    </React.Fragment>
  );
}
